import i18n from '@/locales/i18n'
import TemplatesView from '@/views/TemplatesView/TemplatesView.vue'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const TEMPLATES_ROUTE = '/templates'
export const TEMPLATES_ROUTE_NAME = 'templatesPage'

const routes: RouteType[] = [
    {
        path: TEMPLATES_ROUTE,
        name: TEMPLATES_ROUTE_NAME,
        component: TemplatesView,
        meta: {
            title: i18n.global.t('menu.templates'),
            authRequired: true
        }
    }
]

export default routes
